<template>
  <graph-detail06-template
    :com-group-list="comGroupList"
    :board-ids="[107]"
    field-code="facility-public"
    graph1-title="전체 (공중(다중)이용시설)안전·보건 교육 현황"
    graph2-title="월별 (공중(다중)이용시설)안전·보건 교육 현황"
    graph3-title="기간별 (공중(다중)이용시설)안전·보건 교육 현황"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail06Template from "@/views/graph-detail/GraphDetail06Template.vue";

export default {
  name: "GraphDetail79",
  components: {
    GraphDetail06Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
